export const Periods = Object.freeze({
    evidence: 0,
    commit: 1,
    vote: 2,
    appeal: 3,
    execution: 4,
  });